import { useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import retangle from '../Media/Rectangle.png';
import ferramenta_baixar_videos_img1 from '../Media/ferramenta-baixar-videos-img1.jpeg';
import ferramenta_baixar_videos_img10 from '../Media/ferramenta-baixar-videos-img10.jpeg';
import ferramenta_baixar_videos_img2 from '../Media/ferramenta-baixar-videos-img2.jpeg';
import ferramenta_baixar_videos_img3 from '../Media/ferramenta-baixar-videos-img3.jpeg';
import ferramenta_baixar_videos_img4 from '../Media/ferramenta-baixar-videos-img4.jpeg';
import ferramenta_baixar_videos_img5 from '../Media/ferramenta-baixar-videos-img5.jpeg';
import ferramenta_baixar_videos_img6 from '../Media/ferramenta-baixar-videos-img6.jpeg';
import ferramenta_baixar_videos_img7 from '../Media/ferramenta-baixar-videos-img7.jpeg';
import ferramenta_baixar_videos_img8 from '../Media/ferramenta-baixar-videos-img8.jpeg';
import ferramenta_baixar_videos_img9 from '../Media/ferramenta-baixar-videos-img9.jpeg';
import LoadedPost from './LoadedResponses/LoadedPost';
import LoadingAnimation from './LoadingAnimation';
import './Styles/post.css';

import { Helmet } from 'react-helmet';
import { Carousel } from 'react-responsive-carousel';
import { api } from '../server/api';
import Header from './Header/Header';
import { HeaderMenu } from './HeaderMenu';
import { Tools } from './Tools';
import { Faq } from './Tools/Faq';

const Video = (props) => {
  const [postUrl, setPostUrl] = useState();
  const [newPostId, setPostId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [responseObj, setResponseObj] = useState();

  function getId(url) {
    if (url.split('/p/')[1]) {
      return url.split('/p/')[1].split(' ')[0].slice(0, 11);
    } else {
      alert('Válido somente posts do Instagram');
      return (
        <div className="error-page">
          <h2>Nenhum post encontrado!</h2>
          <p>Veja se você digitou o link corretamente.</p>
        </div>
      );
    }
  }

  function onChangehandler(e) {
    setPostUrl(e.target.value);
  }
  const items = [
    {
      question: 'O que é preciso fazer para baixar vídeo do Instagram?',
      answer:
        'Para baixar vídeo Instagram, você só precisa copiar o link da publicação em questão e colá-lo na ferramenta do ImpulsioneGram feita para o download de conteúdos em vídeo. Importante: o seu perfil do Instagram precisa estar aberto para que o processo dê certo.',
    },
    {
      question:
        'É preciso instalar o ImpulsioneGram no telefone ou no computador para baixar o vídeo do Instagram?',
      answer:
        '   Não. O proprietário e nenhuma outra pessoa saberá que você fez o processo de baixar Reels. No ImpulsioneGram, você tem total segurança e privacidade para fazer o download de quantos vídeos quiser sem o menor problema.',
    },
    {
      question: 'O proprietário do vídeo vai saber que baixei o conteúdo dele?',
      answer:
        '  Se um dos seus objetivos em baixar Reels for repostar os vídeos no seu perfil do Instagram, saiba que temos uma ferramenta específica para fazer isso. Ela facilita o processo desse tipo de publicação e dá o crédito para o Instagrammer original da postagem.',
    },
  ];

  function submitHandler(e) {
    e.preventDefault();
    if (postUrl.length === 0) {
      alert('Empty Post link !');
      return;
    }
    setIsLoading(true);
    fetchPost();
  }

  async function fetchPost() {
    const postId = getId(postUrl);
    setPostId(postId);
    try {
      const { data } = await api.get(
        `video/${postId}`,

        {
          headers: {
            token:
              'dcbbf9d1dd87939fdcf446d5fef2f8ec0ea4382cd4f51bc462211bf7ba83fd47',
          },
        },
      );

      console.log('🚀 ~ file: Video.jsx:76 ~ fetchPost ~ data:', data);

      setResponseObj(data);
      setIsLoading(false);
      setHasLoaded(true);
    } catch (error) {
      console.log('🚀 ~ file: Video.jsx:85 ~ fetchPost ~ error:', error);
    }
  }

  return (
    <>
      <Helmet>
        <title>Baixar Vídeo Instagram Grátis Online e Rápido [2023]</title>
        <meta
          content="Apesar de não ser possível baixar vídeo Instagram por opção nativa, você ainda pode guardar conteúdos neste formato em seu dispositivo. Saiba como!"
          name="description"
        />
      </Helmet>

      <Header />
      <div className="post-response container">
        {isLoading && <LoadingAnimation />}
        {hasLoaded && (
          <LoadedPost responseObj={responseObj} postId={newPostId} />
        )}
      </div>
      <section id="post-section container">
        <HeaderMenu
          description={
            'Insira abaixo o LINK do vídeo escolhido e faça o download de forma online e gratuita.'
          }
          text_description={'Baixe Vídeos do Instragram'}
          submitHandler={submitHandler}
          onChangehandler={onChangehandler}
          placeholder={'Digite o link do vídeo'}
        />
        {/* <SearchForm
          submitHandler={submitHandler}
          onChangehandler={onChangehandler}
          placeholder="Digite o link do vídeo"
        /> */}
      </section>

      <div className="background-white   py-5 color-grey-700">
        <div className="col-12 d-md-flex container">
          <div className="col-md-7 col-12">
            <div className="container text-left">
              <h1 className="text-center pb-5">
                Baixar vídeo Instagram Grátis Online e Rápido [2023]
              </h1>
              <p>
                Já quis <strong>baixar vídeo Instagram</strong> e não conseguiu
                encontrar nenhuma opção nativa para fazer isso? Saiba que você
                não é único. Isso porque, a{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/instagram-guia-completo/"
                  target="_blank"
                  rel="noreferrer"
                >
                  plataforma
                </a>{' '}
                só permite você salvar conteúdos assim dentro da própria rede
                social.
              </p>

              <p>
                Então, se você quiser guardar aquele vídeo importante que
                encontrou em seu dispositivo para vê-lo mais tarde ou até mesmo
                compartilhar com seus amigos(a), por exemplo, vai precisar
                encontrar outro caminho.
              </p>

              <p>
                Caso contrário, será impossível, já que a plataforma não conta
                com uma função do tipo. Dessa forma,{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/automacao-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  ferramentas
                </a>{' '}
                de terceiros aparecem como uma ótima solução para essa
                dificuldade de baixar vídeo Instagram.
              </p>

              <p>
                O serviço funciona de maneira relativamente simples: você copia
                o link do vídeo que precisa salvar e cola dentro da ferramenta
                escolhida. Assim, o download do conteúdo será disponibilizado
                rapidamente.
              </p>

              <p>
                Sendo possível baixar vídeo Instagram de diversas
                funcionalidades da rede social, como{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/colocar-link-stories/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Stories
                </a>
                , Reels e Vídeos. Assim como, para smartphones Android e iOS, e
                computadores.
              </p>

              <p>
                Incrível, não é? Logo abaixo, vamos te explicar passo a passo
                como baixar vídeo Instagram tanto pelo celular quanto pelo PC.
                Com isso, você nunca mais vai ter dores de cabeça para salvar
                aquele conteúdo tão valioso em seu dispositivo.
              </p>

              <p>Boa leitura!</p>
            </div>
          </div>
          <div className="col-md-5 col-12">
            <img
              className=" img-fluid img-responsive"
              src={retangle}
              alt="publicação instagram ícone três pontos topo lateral direita"
              width={'auto'}
            />
          </div>
        </div>

        <div className="  background-gray">
          <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
            <div className="col-md-5 col-12 pe-4">
              <Carousel
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}
                showThumbs={false}
              >
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_videos_img1}
                    alt="publicação instagram ícone três pontos topo lateral direita"
                  />
                </div>
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_videos_img2}
                    alt="seta apontando para copiar link publicação Instagram"
                  />
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 col-12">
              <h2 className="text-center py-4">
                Como baixar vídeo Instagram pelo computador?
              </h2>
              <div className="text-left">
                <h4 className="pb-3">1. Copie o link</h4>
                <p>
                  Se você quer baixar vídeo Instagram pelo{' '}
                  <a
                    href="https://www.impulsionegram.com.br/blog/postar-foto-instagram-pc/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    computador
                  </a>
                  , antes de mais nada, precisa copiar o link do vídeo na versão
                  desktop da rede social. Para isso, você tem duas opções: barra
                  de endereço e ícone de três pontinhos.
                </p>

                <p>
                  A barra de endereço nada mais é do que onde o link do site que
                  você está no momento aparece. Para copiá-lo, basta clicar nela
                  e usar os seguintes atalhos: Ctrl+A e Ctrl+C.
                </p>

                <p>
                  Na segunda opção, você deve clicar no ícone com três pontinhos
                  que fica no canto superior esquerdo da publicação. Em seguida,
                  selecione “Copiar link” para concluir o processo.
                </p>

                <p>
                  Importante: essas duas opções só funcionam para copiar link de
                  vídeos que estão Feed ou
                  <a
                    href="https://www.impulsionegram.com.br/blog/como-fazer-reels-no-instagram/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Reels
                  </a>
                  . No caso de você precisar baixar vídeo Instagram de Stories,
                  só a primeira alternativa vai servir.
                </p>

                <h4 className="pb-3">
                  2. Acesse o site das ferramentas do ImpulsioneGram
                </h4>

                <p>
                  Na próxima etapa, você tem que acessar o site das ferramentas
                  do ImpulsioneGram para continuar o processo. Para isso, basta
                  ir no começo desta página.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
          <div className="col-md-7 col-12">
            <h4 className="pb-3">
              3. Selecione o tipo de conteúdo a ser baixado
            </h4>

            <p>
              Para cada{' '}
              <a
                href="https://www.impulsionegram.com.br/blog/como-criar-conteudo-instagram/"
                target="_blank"
                rel="noreferrer"
              >
                tipo de conteúdo da rede social
              </a>
              , haverá uma opção para você escolher no site de ferramentas do
              ImpulsioneGram. Neste caso, você deverá selecionar “Vídeo” para
              baixar vídeo Instagram.
            </p>

            <h4 className="pb-3">4. Cole o link copiado</h4>

            <p>
              Sabe o link da publicação que foi copiado no primeiro passo do
              processo de baixar vídeo Instagram? Então, é hora de colocá-lo no
              campo em que está escrito “Digite o link do vídeo”.
            </p>

            <h4 className="pb-3">5. Faça o download do vídeo</h4>

            <p>
              Feito isso, clique em “Download”. O vídeo será carregado e você
              poderá assisti-lo novamente para conferir se está tudo certo. Em
              seguida, basta clicar em “Download” de novo e o vídeo será
              baixado.
            </p>

            <h4 className="pb-3">6. Pronto!</h4>

            <p>
              Pronto! Assim, você conclui o processo de baixar vídeo Instagram
              pelo PC. Normalmen te, o arquivo baixado vai para a pasta
              “Download” do armazenamento do computador.
            </p>
          </div>
          <div className="col-md-5 col-12 pe-4">
            <Carousel
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showThumbs={false}
            >
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_videos_img3}
                  alt="seta indicando ícone vídeo ferramenta ImpulsioneGram"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_videos_img4}
                  alt="caixa de escrita para digitar link do vídeo"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_videos_img5}
                  alt="seta indicando botão de download"
                />
              </div>
            </Carousel>
          </div>
        </div>
        <div className="background-gray py-5">
          <div className="container col-12 d-md-flex justify-content-center align-items-center">
            <div className="col-md-5 col-12 pe-4">
              <Carousel
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}
                showThumbs={false}
              >
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_videos_img6}
                    alt="print celular indicando três pontos publicação Instagram"
                  />
                </div>
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_videos_img7}
                    alt="seta apontando para copiar link”"
                  />
                </div>
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_videos_img8}
                    alt="print tela celular com seta indicando para ícone de vídeo"
                  />
                </div>
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_videos_img9}
                    alt="area para digitar link do video em destaque"
                  />
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 col-12">
              <h2 className="text-center py-4">
                Como baixar vídeo Instagram pelo smartphone?
              </h2>

              <h4 className="pb-3">1. Copie o link</h4>

              <p>
                Da mesma forma do que pelo computador, o primeiro passo para
                baixar vídeo Instagram pelo smartphone é copiar o link na
                publicação em questão. Seja no
                <a
                  href="https://www.impulsionegram.com.br/blog/feed-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Feed
                </a>
                , Stories ou Reels.
              </p>

              <p>
                Para isso, você precisa clicar no ícone de três pontinhos, em
                qualquer um destes tipos de publicação. Em seguida, deve
                selecionar a opção “Copiar link”. Desse modo, o link será
                copiado para a área de transferência do seu smartphone.
              </p>

              <h4 className="pb-3">
                2. Acesse o site das ferramentas do ImpulsioneGram
              </h4>

              <p>
                O próximo passo do processo para baixar vídeo Instagram é
                acessar as ferramentas do ImpulsioneGram. Você pode fazer isso
                simplesmente indo para o começo desta página.
              </p>
            </div>
          </div>
        </div>
        <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
          <div className="col-md-7 col-12">
            <h4 className="pb-3">
              3. Selecione o tipo de conteúdo a ser baixado
            </h4>

            <p>
              Para cada tipo de conteúdo da rede social, haverá uma opção para
              você escolher no site de ferramentas do ImpulsioneGram. Neste
              caso, você deverá selecionar “Vídeo” para baixar vídeo Instagram.
            </p>

            <h4 className="pb-3">4. Cole o link copiado</h4>

            <p>
              Depois disso, você deve{' '}
              <a
                href="https://www.impulsionegram.com.br/blog/como-colocar-link-whatsaap-intagram/"
                target="_blank"
                rel="noreferrer"
              >
                inserir o link
              </a>{' '}
              copiado no campo “Digite o link do vídeo”, segurando por 2
              segundos o dedo em cima do local de digitar e clicando em “Colar”
            </p>

            <h4 className="pb-3">5. Faça o download do vídeo</h4>

            <p>
              Inserido o link, clique em “Download”. Dessa forma, o vídeo em
              questão será carregado na página, de modo que você pode assisti-lo
              para verificar se está tudo certo ou clicar em “Download”
              novamente para baixá-lo.
            </p>

            <h4 className="pb-3">6. Pronto!</h4>

            <p>
              Pronto! Assim, o processo para baixar vídeo Instagram pelo
              smartphone será finalizado. Normalmente, o arquivo aparece na
              pasta “Download” do seu dispositivo.
            </p>
          </div>
          <div className="col-md-5 col-12 pe-4">
            <Carousel
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showThumbs={false}
            >
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_videos_img9}
                  alt="area para digitar link do video em destaque"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_videos_img10}
                  alt="seta com indicação para botão de download"
                />
              </div>
            </Carousel>
          </div>
        </div>
      </div>

      <Tools name_tool={'videos'} />
      <div className="background-white">
        <Faq
          title={'DÚVIDAS COMUNS RELACIONADAS A BAIXAR VÍDEO DO INSTAGRAM'}
          questions={items}
        />
      </div>

      <div className="container my-5 simple-download">
        <h3 className="mb-4 text-center">
          SALVE SEUS VÍDEOS FAVORITOS COM A FERRAMENTA DO IMPULSIONEGRAM!
        </h3>
        <div className="col-md-9 col-12 m-auto">
          <p>
            Agora que você sabe exatamente como baixar vídeo Instagram, tanto
            pelo PC quanto pelo celular, já pode começar salvar seus vídeos
            favoritos com a ferramenta do ImpulsioneGram.
          </p>
          <p>
            Como vimos, o processo não é nenhum bicho de 7 cabeças. Pelo
            contrário, seguindo à risca o que explicamos no passo a passo, é
            muito simples baixar vídeo Instagram.
          </p>
          <p>
            E o melhor: você não precisa pagar nada para usar nossa ferramenta.
            Isso mesmo, você pode baixar quantos vídeos quiser sem pagar um só
            centavo. Bom demais, não é?
          </p>
          <p>
            Então, comece a usar o quanto antes a ferramenta do ImpulsioneGram.
            Com ela, você nunca mais terá dores de cabeça para guardar aquele
            conteúdo tão importante que encontrou na rede.
          </p>
        </div>
      </div>
    </>
  );
};

export default Video;
